































import Vue, { PropOptions } from 'vue';
import Paper from '~/components/builders/Paper.vue';
import { CardItem } from '../types';
export default Vue.extend({
    name: 'BaseCard',
    components: { Paper },
    props: {
        header: {
            type: String,
            default: '',
        } as PropOptions<string>,
        subHeader: {
            type: [String, null],
            default: () => null,
        } as PropOptions<string | null>,

        items: {
            type: Array,
            default: () => [],
        } as PropOptions<CardItem[]>,

        error: {
            type: String,
            default: () => null,
        },
        empty: {
            type: String,
            default: () => null,
        },

        hideBorder: Boolean,
        loading: Boolean,
    },
});
